import { render, staticRenderFns } from "./SysRoleList.vue?vue&type=template&id=23850ab4&scoped=true"
import script from "./SysRoleList.vue?vue&type=script&lang=js"
export * from "./SysRoleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23850ab4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23850ab4')) {
      api.createRecord('23850ab4', component.options)
    } else {
      api.reload('23850ab4', component.options)
    }
    module.hot.accept("./SysRoleList.vue?vue&type=template&id=23850ab4&scoped=true", function () {
      api.rerender('23850ab4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/system/adminmanage/SysRoleList.vue"
export default component.exports